import { Helmet } from 'react-helmet';
import { FinanceBatchContainer } from '../components/finance-batch.container';

interface FinanceBatchProps {}

export const FinanceBatch: React.FC<FinanceBatchProps> = () => {
  return (
    <>
      <Helmet>
        <title>Finance - Finance Batch</title>
      </Helmet>
      <FinanceBatchContainer />
    </>
  );
};
